import React from "react";
import "./PanelHeader.css";
import logo_ua from "../../resources/img/logo/ua.png";
import logo_ru from "../../resources/img/logo/ru.png";
import logo_en from "../../resources/img/logo/en.png";
import logo_ee from "../../resources/img/logo/ее.png";
import logo_ro from "../../resources/img/logo/ro.png";
import logo_by from "../../resources/img/logo/by.png";

import ukraine from "../../resources/img/logo/white/ukraine.png";
import ru_by from "../../resources/img/logo/white/russia_and_bel.png";
import moldova from "../../resources/img/logo/white/moldova.png";
import estonia from "../../resources/img/logo/white/estonia.png";
import canada from "../../resources/img/logo/white/canada.png";

import { connect } from "react-redux";
import ModalEditWindow from "./../../components/ModalEditWindow";
import Button from "@material-ui/core/Button";
import { closeRequestModal, openRequestModal } from "../../actions/modals";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import Backdrop from "@material-ui/core/Backdrop";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

import vk from "../../resources/img/vk.png";
import facebook from "../../resources/img/facebook.png";
import inst from "../../resources/img/inst.png";
import telegram from "../../resources/img/telegram.png";
import youtube from "../../resources/img/youtube.png";

class PanelHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mob_menu: false,
    };
  }

  chooseCity() {
    const { t } = this.props;
    this.props.openRequestModal({
      opened: true,
      data: {
        header: t("form.choose_city"),
        modaltype: "ChooseCity",
      },
    });
  }
  render() {
    const { t } = this.props;
    const logo = {
      ru: logo_ru,
      ua: logo_ua,
      en: logo_en,
      ee: logo_ee,
      md: logo_ro,
      by: logo_by,
    };
    const logo_white = {
      ru: ru_by,
      ua: ukraine,
      en: canada,
      ee: estonia,
      md: moldova,
      by: ru_by,
    };
    const handleClose = () => {
      this.setState({ mob_menu: false });
    };
    const handleOpen = () => {
      this.setState({ mob_menu: true });
    };
    let domain = document.location.hostname.split(".")[
      document.location.hostname.split(".").length - 1
    ];
    // domain = "by";
    return (
      <>
        <div className="header mobile" style={{ padding: "20px 25px" }}>
          <Backdrop
            open={this.state.mob_menu}
            onClick={handleClose}
            style={{ zIndex: this.state.mob_menu ? 999 : -1 }}
          >
            <div className="backdropMenu">
              <Grid container spacing={2}>
                <Grid xs={6} item>
                  <div className="header-logo mob">
                    <img src={logo[domain]} alt="Soroban" />
                  </div>
                </Grid>
                <Grid xs={6} item className="closeBtnMob">
                  <CloseIcon onClick={handleClose} />
                </Grid>
                <Grid item xs>
                  <Grid item xs>
                    <div className="headerLinks mob">
                      <a href="#method" onClick={handleClose}>
                        {t("header.nav.1")}
                      </a>
                    </div>
                  </Grid>
                  <Grid item xs>
                    <div className="headerLinks mob">
                      <a href="#gallery" onClick={handleClose}>
                        {t("header.nav.2")}
                      </a>
                    </div>
                  </Grid>
                  <Grid item xs>
                    <div className="headerLinks mob">
                      <a href="#reviews" onClick={handleClose}>
                        {t("header.nav.3")}
                      </a>
                    </div>
                  </Grid>
                  <Grid item xs>
                    <div className="hederPhones_container mob">
                      {this.props.defaultCity && this.props.defaultCity.phones
                        ? this.props.defaultCity.phones.map((el, index) => {
                            return (
                              <div key={index} className="hederPhones">
                                <a href={`tel:${el}`}>{el}</a>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </Grid>
                  <Grid container className="socials">
                    <div>
                      <a href={t("socials.fb")} target="_blank" rel="noopener noreferrer">
                        <img alt="" src={facebook} />
                      </a>
                    </div>
                    <div>
                      <a href={t("socials.inst")} target="_blank" rel="noopener noreferrer">
                        <img alt="" src={inst} />
                      </a>
                    </div>
                    {domain === "ua" ? (
                      <div>
                        <a href={t("socials.tg")} target="_blank" rel="noopener noreferrer">
                          <img alt="" src={telegram} />
                        </a>
                      </div>
                    ) : null}

                    {domain === "ru" || domain === "by" ? (
                      <div>
                        <a href={t("socials.vk")} target="_blank" rel="noopener noreferrer">
                          <img alt="" src={vk} />
                        </a>
                      </div>
                    ) : null}

                    <div>
                      <a href={t("socials.yt")} target="_blank" rel="noopener noreferrer">
                        <img alt="" src={youtube} />
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Backdrop>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid xs item>
                <div className="header-logo">
                  <img src={logo_white[domain]} alt="Soroban" />
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} container alignContent="center">
              <Grid item xs={10} className="chooseCityMob">
                <Button
                  onClick={() => this.chooseCity()}
                  className="headerChooseCityBtn"
                >
                  <LocationOnIcon />
                  {this.props.defaultCity ? (
                    this.props.defaultCity.title[domain]
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={100}
                      height={40}
                    />
                  )}
                </Button>
              </Grid>
              <Grid item xs={2} className="menuHeader">
                <MenuIcon onClick={handleOpen} />
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className="header" style={{ padding: "20px 60px" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid item container xs>
                <Grid item container xs={4}>
                  <Grid xs item>
                    <div className="header-logo">
                      <img src={logo_white[domain]} alt="Soroban" />
                    </div>
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  alignContent="center"
                  xs={8}
                  className="headerLinksContainer"
                >
                  <Grid item xs={3}>
                    <div className="headerLinks">
                      <a href="#method">{t("header.nav.1")}</a>
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <div className="headerLinks">
                      <a href="#gallery">{t("header.nav.2")}</a>
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <div className="headerLinks">
                      <a href="#reviews">{t("header.nav.3")}</a>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} container alignContent="center">
              <Grid item xs={3}>
                <Button
                  onClick={() => this.chooseCity()}
                  className="headerChooseCityBtn"
                >
                  <LocationOnIcon />
                  {this.props.defaultCity ? (
                    this.props.defaultCity.title[domain]
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={100}
                      height={40}
                    />
                  )}
                </Button>
              </Grid>
              <Grid item xs={8} className="phonesHeader">
                <div className="hederPhones_container">
                  {this.props.defaultCity && this.props.defaultCity.phones
                    ? this.props.defaultCity.phones.map((el, index) => {
                        return (
                          <div key={index} className="hederPhones">
                            <a href={`tel:${el}`}>{el}</a>
                          </div>
                        );
                      })
                    : null}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <ModalEditWindow {...this.props} />
      </>
    );
  }
}

const widthConnect = connect(
  (state) => ({
    modalWindow: state.modalWindow,
    defaultCity: state.cities && state.cities.defaultCity,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        closeRequestModal,
        openRequestModal,
      },
      dispatch
    )
);

export default withTranslation()(widthConnect(PanelHeader));
